import {useTimer} from "../hooks/dates";

const units = [
    'days',
    'hours',
    'minutes',
    'seconds',
];

const Timer = ({date, className, containerClassName, unitClassName, valueClassName, ...props}) => {
    const timer = useTimer(date);

    if(!timer) {
        return null;
    }

    return (
        <div {...props} className={`flip-countdown ${className || ''}`}>

            {units.map(unit =>
                <span className="inline-block mb-2 mx-2" key={unit}>
                    <span className="flex">
                        {
                            Array.from(String(timer[unit]).length === 1 ? String(`0${timer[unit]}`) : String(timer[unit]), Number).map((u, i)=>
                                <span className="flip-countdown-card flip" key={unit+'_'+u+i}>
                                    <span className="card-top">{u}</span>
                                    <span className="card-bottom" data-value={u}></span>
                                    <span className="card-back" data-value={u}>
                                    <span className="card-bottom" data-value={u}></span>
                                    </span>
                                </span>
                            )
                        }
                    </span>
                    <span className="mt-2 block text-sm text-gray-600 font-medium">{unit}</span>
                </span>
            )}
        </div>
    )
};

export default Timer;
